// Drop down

function DropDown ($el) {
	var $dropdownWrapper = $el.find('.dropdown');
	
	function createDropdown() {
		var $dropdownItems = $el.find('select option');

		$dropdownItems.each(function(){
			var value = $(this).val();
			$dropdownWrapper.append('<li class="selection" data-option="'+value+'">'+value+'</li>');
		})
	}

	function openDropdown() {
		$dropdownWrapper.addClass('openDropdown');
	}

	function selectDropdown() {
		var selection = $(this).attr('data-option');
		$el.find('.selected').text(selection);
		$el.find('select').val(selection);
		$dropdownWrapper.removeClass('openDropdown');
	}

	this.init = function($el) {
		createDropdown();
		$el.find('.selected').on('click', openDropdown);
		$el.find('.selection').on('click', selectDropdown);

		return this;
	}

	return this.init($el);
}

export default DropDown;



// WEBPACK FOOTER //
// ./src/js/components/drop-down.js